var _path, _path2, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 67,
    viewBox: "0 0 48 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 63.926V3C2 2.44772 2.44772 2 3 2H33.2573L46.4183 15.0456V63.926C46.4183 64.4782 45.9706 64.926 45.4183 64.926H3C2.44772 64.926 2 64.4782 2 63.926Z",
    fill: "#A28EC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4183 15.0456V63.926C46.4183 64.4782 45.9706 64.926 45.4183 64.926H3C2.44772 64.926 2 64.4782 2 63.926V3C2 2.44772 2.44772 2 3 2H33.2573M46.4183 15.0456H34.2573C33.7051 15.0456 33.2573 14.5979 33.2573 14.0456V2M46.4183 15.0456L33.2573 2",
    stroke: "white",
    strokeWidth: 2.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 21,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37,
    width: 32,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIconLight);
export default __webpack_public_path__ + "static/media/ReportIconLight.28e4129f30d7a842e4aafbd059306872.svg";
export { ForwardRef as ReactComponent };